<template>
<div class="page">
    <div class="title">
        <span>每日签到赢好礼</span>
        <div class="checkin-btn" @click="onpressCheckIn">
            <img :src="Images.icon_btn_checkin" />
        </div>
    </div>
    <div class="calendar-box">
        <div class="calendar-tips">今日签到可获得10积分</div>
        <van-calendar :show-title="false" :poppable="false" :show-confirm="false" row-height="30" :readonly="true" :min-date="minDate" :style="{ height: '360px' }" :formatter="formatter" :className="'van-calendar__bottom-info'" />
    </div>
    <div class="bottom">
        <div class="buckle">
            <div></div>
            <div></div>
        </div>
        <div class="tit">
            <div class="line-left"></div>
            <span>超值专区</span>
            <div class="line-right"></div>
        </div>
        <div class="banner">
            <img :src="Images.img_checkin_banner" />
        </div>
    </div>
    <!-- 报名成功 -->
    <van-popup v-model="showCheckinTips">
        <div class="popup-window">
            <p>签到成功</p>
            <span>记得明天继续哦~</span>
            <div class="td-fcc" @click="hideCheckinPop">我知道了</div>
        </div>
    </van-popup>
</div>
</template>

<script>

import moment, { locales } from 'moment';
export default {
    data() {
        return {
            showCheckinTips: false,
            minDate: new Date('2021/1/1'),
            // 医生排班预约次数和day值
            signDatesArr: [],
        }
    },
    mounted() {
        this.requestData();
    },
    methods: {
        onConfirm(res) {
            console.log('res', res)
        },

        // 日期添加备注
        formatter(day) {
            const _curDay = moment(day.date).format('YYYY-MM-DD');
            this.signDatesArr.forEach((item, index) => {
                if (_curDay == item) {
                    day.bottomInfo = '已签到'
                }
            })

            return day
        },

        // 获取签到日志
        async requestData() {
            let url = this.API.daily_sign_log;
            let data = {};
            let result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.signDatesArr = result.data.sign_log;
            } else {
                this.ToastManager(result.msg);
            }
        },

        // 签到
        async onpressCheckIn() {
            let url = this.API.daily_sign_in;
            let data = {};
            let result = await this.$post(url, data);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.requestData();
            }
        },

        // 关闭签到成功提示
        hideCheckinPop() {
            this.showCheckinTips = false
        },
    }
}
</script>

<style lang="less" scoped>
.page {
    min-height: 100vh;
    background-color: #6e4cf6;
    background-image: url('../../assets/img/img_bg_checkin.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
    padding-bottom: 20px;
}

.title {
    font-size: 30px;
    font-weight: wuwairunheiti;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    padding: 30px 0 150px;
    position: relative;
}

.calendar-box {
    margin: 0 15px 10px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.checkin-btn {
    width: 102px;
    height: 102px;
    position: absolute;
    bottom: -10px;
    right: 10px;
    z-index: 1;

    img {
        width: 100%;
        height: 100%;
    }
}

.calendar-tips {
    font-size: 13px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #7181eb;
    list-style: none;
    position: absolute;
    right: 0;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
}

.bottom {
    margin: 15px;
    border-radius: 10px;
    padding: 10px;
    background-color: #fff;
    position: relative;

    .buckle {
        position: absolute;
        top: -20px;
        left: 20px;
        right: 20px;
        display: flex;
        justify-content: space-between;

        >div {
            background: linear-gradient(0deg, #5467df, #5467df, #d3d8fc, #5467df, #5467df);
            width: 5px;
            height: 30px;
        }
    }

    .tit {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 0 10px;

        span {
            font-size: 15px;
            color: #7181eb;
            padding: 0 10px;
        }

        .line-left {
            background: linear-gradient(-90deg, #7181eb, #ffffff);
            width: 60px;
            height: 2px;
        }

        .line-right {
            background: linear-gradient(90deg, #7181eb, #ffffff);
            width: 60px;
            height: 2px;
        }

    }

    .banner {
        img {
            width: 100%;
            display: block;
        }
    }
}

.van-popup {
    background: transparent;
}

.popup-window {
    width: 229px;
    height: 265px;
    box-sizing: border-box;
    padding-top: 100px;
    background-image: url('../../assets/img/img_showpopup.png');
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
        margin-bottom: 5px;
        font-size: 18px;
        color: #7181EB;
        font-weight: 500;
    }

    span {
        margin-bottom: 10px;
        font-size: 14px;
        color: #7181EB;
    }

    div {
        width: 141px;
        height: 33px;
        background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
        border-radius: 3px;
        font-size: 14px;
        color: #fff;
        margin-top: 10px;
        letter-spacing: 2px;
    }
}

// 日历备注
/deep/ .van-calendar__header-subtitle {
    text-align: left;
    padding-left: 10px;
    background-color: #f8f8f8;
}

/deep/ .van-calendar__weekday {
    line-height: 50px;
}

/deep/ .van-calendar__bottom-info {
    color: #ffa734;
    zoom: 0.9;
}

/deep/ .van-calendar__day {
    padding-bottom: 15px;
}

/deep/ .van-calendar__selected-day {
    background-color: transparent;
    color: #5d73ec;
}
</style>
